import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/dental/Button";

const NotFound = () => (
  <section className="bg-[#FBF8F1] min-h-[60vh] flex items-center justify-center px-6 py-24">
    <div className="text-center max-w-xl">
      <p className="font-script text-6xl md:text-7xl gold-gradient-text">Oops!</p>
      <h1 className="font-cinzel text-3xl md:text-5xl gold-gradient-text uppercase tracking-[0.2em] mt-2">
        404 — Page Not Found
      </h1>
      <div className="flex items-center justify-center gap-3 mt-5">
        <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#B79A68]" />
        <span className="w-1.5 h-1.5 rotate-45 bg-[#B79A68]" />
        <span className="h-px w-12 bg-gradient-to-l from-transparent to-[#B79A68]" />
      </div>
      <p className="text-[#4E5750]/85 leading-relaxed mt-6">
        The page you are looking for may have moved or no longer exists. Let&apos;s get you back to your smile journey.
      </p>
      <div className="mt-8 flex justify-center gap-3 flex-wrap">
        <Button to="/">Back to Home</Button>
        <Link to="/contact" className="font-cinzel uppercase text-[11px] tracking-[0.3em] text-[#7D6A42] hover:text-[#5F4F30] py-3">
          Contact Us →
        </Link>
      </div>
    </div>
  </section>
);

export default NotFound;
